 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis
 let new_service_data=getEnv(tag).service_data

 const service_run = process.env.NODE_ENV === 'production' ? window.gtaAiConfig.service_run : '/service_run'

export default {
  /**
   * 统计文件压缩包里的数量
   */
  FileInZipCount: `${new_service_basis}/ai/training/fileUpload/fileInZipCount`,
  /**
   * 单个文件上传进度条
   */
  /**
   * 通过数据集ID下载文件
   */
  downloadDatesetFile: `${new_service_data}/api/resourceFile/downloadDatesetFile`,
  /**
   * 单文件上传
   */
  // UploadFile: `${new_service_data}/res/open/basic/upload`, // 资源平台
  UploadFile: `${new_service_data}/ai/training/file/upload`,
  /**
   * 多文件上传
   */
  // UploadMultipleFile: `${new_service_data}/res/open/basic/uploadFileList`, // 资源平台 
  UploadMultipleFile: `${new_service_data}/ai/training/file/uploadFileList`,
  /**
   *  校验图片jpg|jpeg格式
   */
  verifyImgs: `${service_run}/others/verify_imgs/`,
  /**
   * UC平台上传图片
   */
  UploadImage: `http://10.1.135.40:5020/uc/userloginandreg/uploadImagesFile`,
}
